import axiosInstance from "../../axiosInstance";

const BASE_URL = "/hrm/attendance-confirmation";

export const getAttendanceConfirmationPeriod = async (year_month) => {
  const res = await axiosInstance.get(`${BASE_URL}/period`, { params: { year_month } });
  return res.data;
};

export const getMyAttendanceConfirmationOverview = async (year_month) => {
  const res = await axiosInstance.get(`${BASE_URL}/my-overview`, { params: { year_month } });
  return res.data;
};

/** HCNS: danh sách NV trong tháng để xem phiếu / phê duyệt kỳ — quyền C */
export const getAttendanceConfirmationEmployees = async (params) => {
  const res = await axiosInstance.get(`${BASE_URL}/employees`, {
    params: {
      year_month: params.year_month,
      ...(params.branch_id ? { branch_id: params.branch_id } : {}),
    },
  });
  return res.data;
};

/** HCNS: phiếu công chi tiết một NV (cùng cấu trúc my-overview) — quyền C */
export const getAttendanceConfirmationEmployeeOverview = async ({ year_month, employee_id }) => {
  const res = await axiosInstance.get(`${BASE_URL}/employee-overview`, {
    params: { year_month, employee_id },
  });
  return res.data;
};

/** HCNS: duyệt / không duyệt phiếu công một NV — quyền C */
export const postAttendanceConfirmationEmployeeReview = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/employee-review`, payload);
  return res.data;
};

export const postAttendanceHourExplanation = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/explanation`, payload);
  return res.data;
};

/** HCNS: duyệt / từ chối giải trình (áp số liệu nếu approved) — quyền C */
export const postAttendanceExplanationReview = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/explanation-review`, payload);
  return res.data;
};

export const deleteAttendanceHourExplanation = async (payload) => {
  const res = await axiosInstance.delete(`${BASE_URL}/explanation`, { data: payload });
  return res.data;
};

/** Nhân viên: xác nhận đồng ý tổng bảng công (song song với giải trình theo ngày) — quyền U */
export const postAcknowledgeAttendancePayroll = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/acknowledge-payroll`, payload);
  return res.data;
};

export const deleteAttendancePayrollAcknowledgment = async (payload) => {
  const res = await axiosInstance.delete(`${BASE_URL}/acknowledge-payroll`, { data: payload });
  return res.data;
};

/** HCNS: danh sách đã đồng ý bảng công — quyền C */
export const getAttendancePayrollAgreements = async (params) => {
  const res = await axiosInstance.get(`${BASE_URL}/payroll-agreements`, { params });
  return res.data;
};

export const postAttendanceConfirmationRequest = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/request`, payload);
  return res.data;
};

export const postAttendanceConfirmationClose = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/close`, payload);
  return res.data;
};

/** Chỉ Super Admin — máy chủ kiểm tra role */
export const postAttendanceConfirmationReopenPeriod = async (payload) => {
  const res = await axiosInstance.post(`${BASE_URL}/reopen-period`, payload);
  return res.data;
};

export const getAttendanceConfirmationExplanations = async (params) => {
  const res = await axiosInstance.get(`${BASE_URL}/explanations`, { params });
  return res.data;
};

/** Dữ liệu để FE dựng Excel (pivot giờ thực tế + kỳ + giải trình) — quyền C */
export const getAttendanceConfirmationPayrollExportData = async (params) => {
  const res = await axiosInstance.get(`${BASE_URL}/export-payroll-data`, {
    params: {
      year_month: params.year_month,
      ...(params.branch_id ? { branch_id: params.branch_id } : {}),
    },
  });
  return res.data;
};

/** HCNS: dữ liệu báo cáo PDF sau khi đóng kỳ — quyền C */
export const getAttendanceConfirmationClosedPeriodReport = async (params) => {
  const res = await axiosInstance.get(`${BASE_URL}/closed-period-report`, {
    params: {
      year_month: params.year_month,
      ...(params.branch_id ? { branch_id: params.branch_id } : {}),
    },
  });
  return res.data;
};

/** Nhật ký xác nhận / giải trình — quyền R */
export const getAttendanceConfirmationActivityLog = async (params) => {
  const res = await axiosInstance.get(`${BASE_URL}/activity-log`, {
    params: {
      year_month: params.year_month,
      ...(params.branch_id ? { branch_id: params.branch_id } : {}),
    },
  });
  return res.data;
};
